import React from "react"
import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"

import { useDeliveryLocationToggle } from "./components/useDeliveryLocationToggle"
import { MeetingServiceConfig, MeetingServiceTabValues } from "../form/formTypes"
import { CreateOrderDialogType, SelectedMainUserState } from "../../createOrderTypes"
import { useCreateOrderDialogType } from "../../hooks/useCreateOrderDialogType"
import { ExtraServices } from "./extraServices/ExtraServices"
import { GroupFields } from "./components/GroupFields"
import { IconBadge } from "../../../badges/IconBadge"
import { AccordionSection } from "./AccordionSection"

const useStyles = makeStyles()((theme) => ({
    disabledContent: {
        pointerEvents: "none",
    },
    defaultButton: {
        color: theme.palette.tailwind.blue[500],
        fontSize: "1rem",
        fontWeight: "400",
        padding: "0",
    },
}))

type Props = {
    meetingServiceConfiguration: MeetingServiceConfig
    expandedAccordionKey: string | null
    setExpandedAccordionKey: (k: string | null) => void
    dialogType: CreateOrderDialogType
    user: SelectedMainUserState
    orderType: any
}

export function DrawerSections({
    meetingServiceConfiguration,
    expandedAccordionKey,
    setExpandedAccordionKey,
    dialogType,
    user,
}: Props) {
    const { classes } = useStyles()
    useFormikContext<MeetingServiceTabValues>()

    const { isSpecialOrder } = useCreateOrderDialogType(dialogType)

    const { sections } = meetingServiceConfiguration

    const visibleSections = (sections ?? []).filter(({ showInDrawer }) => showInDrawer !== false)

    const { deliveryFields, showOtherLocationField, setShowOtherLocationField } =
        useDeliveryLocationToggle(visibleSections)

    return (
        <>
            {visibleSections.map(({ title, groups }, index) => (
                <AccordionSection
                    key={`section-${index}`}
                    accordionKey={`section-${index}`}
                    expandedAccordionKey={expandedAccordionKey}
                    setExpandedAccordionKey={setExpandedAccordionKey}
                    title={title}
                    updateAccordionContentUi={isSpecialOrder ? classes.disabledContent : ""}
                    icon={<IconBadge variant="numeric" color="blue" value={index + 1} />}
                >
                    {groups.map((group, groupIndex) => {
                        const groupTitle = group.title
                        return (
                            <React.Fragment key={`section-${index}-group-${groupIndex}`}>
                                <GroupFields
                                    title={groupTitle}
                                    fields={group.fields}
                                    meetingServiceConfiguration={meetingServiceConfiguration}
                                    user={user}
                                    defaultButtonClass={classes.defaultButton}
                                    deliveryFields={deliveryFields}
                                    showOtherLocationField={showOtherLocationField}
                                    setShowOtherLocationField={setShowOtherLocationField}
                                />
                            </React.Fragment>
                        )
                    })}
                    {index === 1 && <ExtraServices userId={user.userId} dialogType={dialogType} />}
                </AccordionSection>
            ))}
        </>
    )
}
